import Component_VR_fd420552991523267fd19bd728aaeb47 from "../../../../content/examples/vr/VR";
import Devtool_VR_fd420552991523267fd19bd728aaeb47 from "!!@devtool/loader!../../../../content/examples/vr/VR";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_VR_fd420552991523267fd19bd728aaeb47,
  Devtool_VR_fd420552991523267fd19bd728aaeb47,
  DevTool,
  React
};